module.exports = __webpack_public_path__ + "static/savinglives_card_img4@2x-927d9da3959e24e3ca132bcf57addfb0.jpg";